// DashboardPage — cycle 1 stub
export default function DashboardPage() {
  return (
    <div style={{ padding: 'var(--sp-8)', color: 'var(--fg-3)', fontFamily: 'var(--font-sans)' }}>
      Dashboard — coming in cycle 2.
    </div>
  );
}
